import { render, staticRenderFns } from "./StudentTeamProfiles.vue?vue&type=template&id=3d009c31&"
import script from "./StudentTeamProfiles.vue?vue&type=script&lang=js&"
export * from "./StudentTeamProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports